export const SERVER_URL = "https://do-calculate.com/api";

export const otherCalculators_Fr = [
  // EXISTING CALCULATORS
  {
    name: "Générateur de mot de passe",
    link: "/calculator/fr/random-password-generator/",
    description:
      "Générateur de mot de passe, mots de passe forts, protection de compte, sécurité des données, sécurité Internet, générateur de mot de passe aléatoire, lettres, chiffres et symboles, sécurité des comptes personnels, création d'un mot de passe fort.",
    showMain: true,
  },
  {
    name: "Générateur de nom musulman",
    link: "/calculator/fr/random-name-generator/",
    description:
      "Utilisez le générateur de noms pour découvrir une large variété de noms uniques et beaux. Que vous cherchiez des noms arabes, occidentaux, islamiques, orientaux, luxueux ou rares, ce générateur offre diverses options pour trouver le nom parfait pour votre nouveau-né !",
    showMain: true,
  },
  {
    name: "Générateur de nombre aléatoire",
    link: "/calculator/fr/random-number-generator/",
    description:
      "Utilisez le générateur de nombres pour découvrir une large variété de nombres uniques et beaux. Que vous cherchiez des nombres arabes, occidentaux, islamiques, orientaux, luxueux ou rares, ce générateur offre diverses options pour trouver le nombre parfait pour votre nouveau-né !",
    showMain: true,
  },
  {
    name: "Compteur électronique de Dhikr (compteur de pointages)",
    link: "/calculator/fr/tally-counter/",
    description:
      "Le compteur électronique de Dhikr (compteur de pointages) vous aide à suivre votre nombre de Dhikr facilement et commodément. Vous pouvez l'utiliser pour compter votre Dhikr pendant les prières ou à tout autre moment où vous souhaitez pratiquer le souvenir d'Allah. Le compteur est conçu pour être convivial et fiable, rendant votre pratique spirituelle plus focalisée et organisée.",
    showMain: true,
  },

  // NEW OTHER CALCULATORS (22)
  {
    name: "Calculatrice d'absence",
    link: "/calculator/fr/absence-calculator/",
    description:
      "Calculatrice pour calculer les jours d'absence.",
    showMain: true,
  },
  {
    name: "Calculatrice de durée de vie de la batterie",
    link: "/calculator/fr/battery-life-calculator/",
    description:
      "Calculatrice pour estimer la durée de vie d'une batterie.",
    showMain: true,
  },
  {
    name: "Calculatrice d'électricité",
    link: "/calculator/fr/electricity-calculator/",
    description:
      "Calculatrice pour les calculs électriques.",
    showMain: true,
  },
  {
    name: "Calculatrice de temps d'apprentissage de l'anglais",
    link: "/calculator/fr/english-learning-time-calculator/",
    description:
      "Calculatrice pour estimer le temps nécessaire pour apprendre l'anglais.",
    showMain: true,
  },
  {
    name: "Calculatrice de temps d'apprentissage du français",
    link: "/calculator/fr/french-learning-time-calculator/",
    description:
      "Calculatrice pour estimer le temps nécessaire pour apprendre le français.",
    showMain: true,
  },
  {
    name: "Calculatrice de temps d'apprentissage de l'allemand",
    link: "/calculator/fr/german-learning-time-calculator/",
    description:
      "Calculatrice pour estimer le temps nécessaire pour apprendre l'allemand.",
    showMain: true,
  },
  {
    name: "Calculatrice de différence de hauteur",
    link: "/calculator/fr/height-difference-calculator/",
    description:
      "Calculatrice pour calculer la différence de hauteur entre deux points.",
    showMain: true,
  },
  {
    name: "Calculatrice de vitesse Internet",
    link: "/calculator/fr/internet-speed/",
    description:
      "Calculatrice pour tester et analyser la vitesse d'Internet.",
    showMain: true,
  },
  {
    name: "Générateur de noms",
    link: "/calculator/fr/name-generator/",
    description:
      "Générateur de noms aléatoires.",
    showMain: true,
  },
  {
    name: "Calculatrice des heures supplémentaires",
    link: "/calculator/fr/overtime-calculator/",
    description:
      "Calculatrice pour calculer les heures supplémentaires et les compensations.",
    showMain: true,
  },
  {
    name: "Calculatrice de mot de passe",
    link: "/calculator/fr/password-generator/",
    description:
      "Générateur de mot de passe sécurisé.",
    showMain: true,
  },
  {
    name: "Décorateur de texte",
    link: "/calculator/fr/text-decorator/",
    description:
      "Outil pour décorer et styliser du texte.",
    showMain: true,
  },
  {
    name: "Compteur de mots",
    link: "/calculator/fr/word-counter/",
    description:
      "Outil pour compter le nombre de mots dans un texte.",
    showMain: true,
  },
];
